var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from 'react-router-dom';
import { useJune } from "../../data/hooks/useJune";
import { request } from '../../services/requestService';
import View from '../../components/styledComponents/View';
import ReactLoading from 'react-loading';
import { colors } from '../../styles/theme';
import { useUserRoles } from '../../hooks/useWorkspaceAccess';
function Auth() {
    var _this = this;
    var _a = useAuth0(), user = _a.user, isAuthenticated = _a.isAuthenticated, isLoading = _a.isLoading, getAccessTokenSilently = _a.getAccessTokenSilently;
    var navigate = useNavigate();
    var analytics = useJune();
    var isBuyer = useUserRoles().isBuyer;
    useEffect(function () {
        var authenticate = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!isLoading && isAuthenticated && user && analytics)) return [3 /*break*/, 2];
                        return [4 /*yield*/, request.post('/Authenticate', {
                                key: user.sub,
                                email: user.email,
                                emailVerified: user.email_verified,
                                firstName: user.given_name,
                                lastName: user.family_name,
                                emailConfirmed: user.email_verified,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            analytics.identify(user.sub, {
                                email: user.email,
                                // Optional
                                name: user.name || user.nickname || 'Unknown Name',
                                avatar: user.picture
                            });
                            if (response.data === true) {
                                analytics.track("Sign Up");
                            }
                        }
                        isBuyer ? navigate('/call-conversations') : navigate('/');
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        authenticate()
            .catch(console.error);
    }, [getAccessTokenSilently, isLoading, isAuthenticated, user, analytics]);
    return (_jsx(View, __assign({ height: "100vh", flex: true, aCenter: true, jCenter: true }, { children: _jsx(ReactLoading, { type: "spin", color: colors.theme, height: 30, width: 30 }) })));
}
export default Auth;
